import axios from 'axios';
import { API_BASE_URL } from 'config';

export const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error.response.data),
);

export const optionsMapper = (options: string[]) => options.map((value) => ({ value, label: value }));
